export default {
  nav: {
    home: 'Startseite',
    about: 'Das Haus',
    gallery: 'Bildergalerie',
    booking: 'Buchung',
    contact: 'Kontakt',
  },
  hero: {
    title: 'Ihr Ferienhaus an der Nordsee',
    subtitle: 'Erholsame Tage in Dornumersiel - wo Deich, Watt und Meer aufeinandertreffen',
    ctaPrimary: 'Jetzt buchen',
    ctaSecondary: 'Mehr erfahren',
  },
  about: {
    title: 'Willkommen in Ihrem Ferienhaus',
    description1: 'Unser charmantes Ferienhaus in Dornumersiel bietet Ihnen den perfekten Rückzugsort für erholsame Tage an der Nordseeküste. Umgeben von der einzigartigen Natur des UNESCO-Welterbes Wattenmeer finden Sie hier Ruhe und Entspannung.',
    description2: 'Das Haus verfügt über moderne Ausstattung bei gleichzeitig gemütlichem Ambiente. Genießen Sie lange Spaziergänge am Deich, Wattwanderungen bei Ebbe oder einfach nur die frische Seeluft auf der Terrasse.',
    badge: 'Nordseeküste',
    guests: 'Bis zu 6 Gäste',
    bedrooms: '3 Schlafzimmer',
    bathrooms: '2 Bäder',
    pets: 'Haustiere willkommen',
  },
  features: {
    title: 'Ausstattung & Highlights',
    subtitle: 'Alles, was Sie für einen perfekten Urlaub brauchen',
    items: {
      wifi: {
        title: 'WLAN',
        description: 'Highspeed-Internet im gesamten Haus',
      },
      parking: {
        title: 'Parkplatz',
        description: 'Kostenfreier Stellplatz direkt am Haus',
      },
      kitchen: {
        title: 'Vollausgestattete Küche',
        description: 'Inkl. Geschirrspüler, Kühlschrank & Backofen',
      },
      terrace: {
        title: 'Sonnenterrasse',
        description: 'Mit Gartenmöbeln und Grillmöglichkeit',
      },
      heating: {
        title: 'Fußbodenheizung',
        description: 'Behagliche Wärme auch in der Nebensaison',
      },
      tv: {
        title: 'Smart-TV',
        description: 'Streaming-Dienste für gemütliche Abende',
      },
      washing: {
        title: 'Waschmaschine',
        description: 'Inkl. Wäschetrockner im Hauswirtschaftsraum',
      },
      bike: {
        title: 'Fahrradverleih',
        description: 'Fahrräder können vor Ort gemietet werden',
      },
    },
  },
  gallery: {
    title: 'Bildergalerie',
    subtitle: 'Lassen Sie sich von unserem Ferienhaus verzaubern',
    altExterior: 'Außenansicht des Ferienhauses',
    altLiving: 'Gemütliches Wohnzimmer',
    altKitchen: 'Moderne Küche',
    altBedroom: 'Helles Schlafzimmer',
    altBathroom: 'Modernes Badezimmer',
    altTerrace: 'Sonnige Terrasse',
    altBeach: 'Nordseestrand in der Nähe',
    altDike: 'Deichlandschaft Dornumersiel',
    altHarbor: 'Hafen von Dornumersiel',
    altNature: 'Watt und Natur',
  },
  location: {
    title: 'Lage & Umgebung',
    subtitle: 'Dornumersiel - Ihr Tor zum Wattenmeer',
    description: 'Das Ferienhaus liegt im malerischen Dornumersiel, einem idyllischen Küstenort im Herzen Ostfrieslands. In unmittelbarer Nähe finden Sie den Nordseestrand, den malerischen Hafen und unzählige Rad- und Wanderwege entlang des Deichs.',
    distanceBeach: '5 Min. zum Strand',
    distanceHarbor: '3 Min. zum Hafen',
    distanceTown: '10 Min. nach Dornum',
    distanceWadden: 'Direkt am Wattenmeer',
  },
  booking: {
    title: 'Online buchen',
    subtitle: 'Reservieren Sie Ihren Urlaub direkt online',
    description: 'Unser Ferienhaus können Sie auch über diese Plattform buchen. Wählen Sie einfach Ihre Wunschtermine und senden Sie die Anfrage ab.',
    iframePlaceholder: 'Buchungssystem wird geladen...',
    externalCta: 'Auch auf Fewo-direkt buchen',
  },
  contact: {
    title: 'Kontakt',
    subtitle: 'Fragen? Wir sind für Sie da!',
    form: {
      nameLabel: 'Ihr Name',
      namePlaceholder: 'Max Mustermann',
      emailLabel: 'E-Mail-Adresse',
      emailPlaceholder: 'max@beispiel.de',
      phoneLabel: 'Telefon (optional)',
      phonePlaceholder: '+49 123 456789',
      messageLabel: 'Ihre Nachricht',
      messagePlaceholder: 'Ihre Anfrage oder Nachricht an uns...',
      submit: 'Nachricht senden',
      success: 'Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.',
      error: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
      privacyHint: 'Mit dem Absenden stimmen Sie unserer Datenschutzerklärung zu.',
    },
    info: {
      phone: 'Telefon',
      email: 'E-Mail',
      address: 'Adresse',
      addressValue: 'Musterstraße 1, 26553 Dornumersiel',
      availability: 'Erreichbarkeit',
      availabilityValue: 'Mo - Fr: 9:00 - 18:00 Uhr',
    },
  },
  footer: {
    rights: 'Alle Rechte vorbehalten',
    impressum: 'Impressum',
    datenschutz: 'Datenschutz',
    backToTop: 'Nach oben',
    madeWith: 'Mit Liebe gemacht in Dornumersiel',
  },
  notFound: {
    title: 'Seite nicht gefunden',
    description: 'Die gewünschte Seite konnte leider nicht gefunden werden.',
    backHome: 'Zurück zur Startseite',
  },
};